import { useState } from "react";

const faqs = [
  {
    question: "Do you sell both used and brand-new cars?",
    answer: "Yes, we offer a variety of both used and brand-new cars. Our listings are updated regularly to provide you with the best options available in Cameroon."
  },
  {
    question: "Where can I buy genuine spare parts?",
    answer: "We provide high-quality spare parts for different car brands. Visit our spare parts section to find the right part for your vehicle."
  },
  {
    question: "Do you sell car tires and lubricants?",
    answer: "Yes, we offer a range of tires for different vehicles and high-quality lubricants to keep your car running smoothly."
  },
  {
    question: "How can I improve my car’s fuel efficiency?",
    answer: "Regular maintenance, proper tire pressure, avoiding aggressive driving, and using the recommended fuel type can help improve fuel efficiency."
  },
  {
    question: "What should I do if my check engine light turns on?",
    answer: "If your check engine light turns on, check if your gas cap is properly closed. If the problem persists, visit a mechanic for a full diagnostic check."
  },
  {
    question: "How often should I change my engine oil?",
    answer: "Engine oil should be changed every 5,000 to 10,000 km, depending on the type of oil and your driving conditions."
  },
  {
    question: "What’s the best way to maintain my car’s battery?",
    answer: "Ensure your battery terminals are clean, avoid leaving electronics on when the engine is off, and check the battery’s charge regularly."
  }
];

export default function FAQPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center p-6">
      <h1 className="text-3xl font-bold mb-6">Frequently Asked Questions</h1>
      <div className="w-full max-w-3xl">
        {faqs.map((faq, index) => (
          <div key={index} className="mb-4 border-b pb-4">
            <button
              className="w-full text-left text-lg font-semibold p-4 bg-white shadow-md rounded-md"
              onClick={() => toggleFAQ(index)}
            >
              {faq.question}
            </button>
            {openIndex === index && (
              <p className="p-4 text-gray-700 bg-gray-50 rounded-md mt-2">{faq.answer}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
